require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-should-world-bank-funded-covid-19-additional-financing.json") })
        }
      }, "path---en-us-update-how-should-world-bank-funded-covid-19-additional-financing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-should-world-bank-funded-covid-19-additional-financing!./.cache/json/en-us-update-how-should-world-bank-funded-covid-19-additional-financing.json
// module id = 739
// module chunks = 231608221292675